import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {//要设置的全局访问的state对象
    complete: 0
    //要设置的初始属性值
};


const mutations = {
    changeComplete(state, newVal) {
        state.complete = newVal
    }
};


const actions = {
    changeComplete(context, newVal) {
        context.commit('changeComplete', newVal)
    }
};

const getters = {
    getComplete(state) {
        return state.complete
    }
};

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js